import React from "react";

const ITEMS = [
  "RECURPLUS",
  "GRC VERIFY",
  "CONNECTGRC",
  "BUILT LEAN",
  "BUILT TO LAST",
  "ANANTORA",
  "IN DEVELOPMENT",
  "SOFTWARE THAT ENDURES",
];

const MarqueeBand = () => {
  const doubled = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];

  return (
    <div
      data-testid="marquee-band"
      style={{
        overflow: "hidden",
        borderTop: "1px solid #1A1A1A",
        borderBottom: "1px solid #1A1A1A",
        padding: "14px 0",
        backgroundColor: "#0A0A0A",
      }}
    >
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span
            key={i}
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "10px",
              letterSpacing: "0.3em",
              color: i % 6 === 5 ? "#FF3B00" : "#3A3A3A",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              padding: "0 40px",
              display: "inline-flex",
              alignItems: "center",
              gap: "40px",
            }}
          >
            {item}
            {i % 3 !== 2 && (
              <span style={{ color: "#FF3B00", fontSize: "5px", lineHeight: 1 }}>●</span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeBand;
